/** The header logo's width vars, resolved in one place so the precedence is
 *  testable in node (the storefront's vitest has no DOM).
 *
 *  `--dk-logo-w-m` must always carry a REAL width. `styles.css` reads it as
 *  `var(--dk-logo-w-m, var(--dk-logo-w, 140px))`, and a custom property that is
 *  always emitted can never let that fallback fire — so emitting `0px` for "no
 *  mobile width set" meant `max-width: 0` on `.dk-logo__img`, i.e. an image logo
 *  that was invisible on every phone. The fallback therefore lives here.
 */

/** What this component has always used for an unsized logo. */
export const DEFAULT_LOGO_WIDTH = 140

const px = (v: unknown) => {
  const n = Number(v ?? 0)
  // Rejects NaN and 0-or-less alike: both mean "nothing usable was configured",
  // and a negative max-width is invalid CSS that would drop the declaration.
  return Number.isFinite(n) && n > 0 ? n : 0
}

/**
 * @param block  the header section's `logo` block settings
 * @param themeWidth  `ThemeSettings.logo.width`, the pre-section source
 */
export function logoWidthVars(
  block: Record<string, unknown> = {},
  themeWidth?: unknown,
): Record<string, string> {
  const desktop = px(block.desktop_logo_width) || px(themeWidth) || DEFAULT_LOGO_WIDTH
  return {
    "--dk-logo-w": `${desktop}px`,
    "--dk-logo-w-m": `${px(block.mobile_logo_width) || desktop}px`,
  }
}
